import React, { useState, useEffect, ReactElement } from 'react';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
import styled from '@emotion/styled';

interface IProps {
    title?: ReactElement;
    icon?: ReactElement;
    lazyLoadChild?: JSX.Element;
    wrapperStyle?: React.CSSProperties;
    titleStyle?: React.CSSProperties;
    arrowStyle?: React.CSSProperties;
    childStyle?: React.CSSProperties;
    isOpened?: boolean;
    setIsOpened?: (state) => void;
    forwardRef?: React.RefObject<HTMLDivElement>;
    children?: JSX.Element | JSX.Element[];
}

const CollapseContainer = styled.div`
    padding: 10px 25px;
    border-bottom: solid 1px ${({ theme }) => theme.colors.iron[100]};
`;
const CollapseContent = styled.div``;
const CollapseTitle = styled.div`
    display: flex;
    flex: 1 1 0;
    align-items: center;
    justify-content: space-between;
`;
const StyledArrowDownIcon = styled(ArrowDownIcon)<{ rotate: boolean }>`
    fill: rgba(26, 24, 30, 0.5);
    transition: transform 0.15s ease-in-out;
    padding: 10px 5px;
    box-sizing: content-box;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    transform: ${({ rotate }) => (rotate ? 'rotate(180deg)' : 'rotate(0)')};
`;

export const CollapsibleDropDown = ({
    title,
    icon,
    lazyLoadChild,
    wrapperStyle,
    titleStyle,
    arrowStyle,
    childStyle,
    isOpened = false,
    forwardRef,
    children,
    setIsOpened,
}: IProps) => {
    const [isCollapsed, setCollapsedState] = useState(!isOpened);

    const collapseButtonToggler = () => {
        setCollapsedState((prevState) => {
            setIsOpened?.((prevState) => !prevState);
            return !prevState;
        });
    };

    useEffect(() => {
        if (isOpened) {
            setIsOpened?.(true);
            setCollapsedState(false);
        }
    }, [isOpened]);
    return (
        <CollapseContainer ref={forwardRef} style={wrapperStyle}>
            <CollapseTitle style={titleStyle} onClick={() => collapseButtonToggler()}>
                <span>
                    {icon}
                    {title}
                </span>
                <StyledArrowDownIcon
                    rotate={!isCollapsed}
                    style={arrowStyle}
                    width={20}
                    height={20}
                />
            </CollapseTitle>
            {!isCollapsed && (
                <CollapseContent style={childStyle}>{lazyLoadChild ?? children}</CollapseContent>
            )}
        </CollapseContainer>
    );
};
